import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { useWindowSize } from "@uidotdev/usehooks"; 
export const Headerkeyfeatures = ( {nameHader, underlineHeader, desHeader, descac , check, nameHader1 } ) => {
    const { t ,i18n } = useTranslation()
    const { width } = useWindowSize()
    return (
       
     
            <div className=" relative">{i18n.language === "en" ? (

                        <div className=" flex flex-col gap-[15px] items-center ">
                            
                        <h1 className="text-center text-5xl text-[#1C2045] font-extrabold  max-w-[1000px] leading-[60px] sm:text-4xl">
                            
                            {nameHader}
                            {
                                check == true ? (
                                    width > 358 ? (
                                        <span className="border-b-[10px] pl-2 inline-block  h-[50px] border-[var(--tree-poppy)] sm:h-[40px]">
                                        {underlineHeader}
                                    
                                        </span>
                                    ) : (
                                        <>
                                            <span className="border-b-[10px]  pl-2 inline-block sm:h-[40px] h-[50px] border-[var(--tree-poppy)]">
                                            {t("industries.student.key")}
                                        
                                            </span>
                                            <span className="border-b-[10px]  pl-2 inline-block sm:h-[40px] h-[50px] border-[var(--tree-poppy)]">
                                            {t("industries.student.features")}
                                        
                                            </span>
                                        </>
                                    )
                                ): (
                                <span className="border-b-[10px]  pl-2 inline-block  h-[50px] border-[var(--tree-poppy)] sm:h-[40px]">
                                        {underlineHeader}
                                    
                                    </span>
                            
                                )
                            }
                          
                            
                            
                                <span>{nameHader1}</span>
                        
                        </h1>
                        <p className=" text-center text-[#3A505F] text-[18px] font-normal max-w-[950px]">{desHeader}</p>
                        </div>
            ) : (
                width < 358 ? ( 
                <div className=" flex flex-col gap-[15px] items-center " >
                    <h1 className="text-center text-5xl leading-tight text-[#1C2045] font-extrabold sm:text-4xl">
                        <span className="border-b-[10px]  inline-block h-[50px] border-[var(--tree-poppy)] sm:h-[40px]">
                        {descac}
                        </span>
                        <br />
                        {/* <span className="border-b-[10px]  inline-block h-[50px] border-[var(--tree-poppy)] sm:h-[40px]">
                        {tinh}
                        </span>
                        <br /> */}
                        {check == true ? (
                                <div>
                               
                                    {nameHader1}
                                </div>
                              
                            ) : <span>
                            {underlineHeader}
                            </span>}
                        
                    </h1>
                  
                    <p className="text-center text-[18px] text-[#3A505F] max-w-[1000px]">{desHeader}</p>
                </div>
                ) : (
                <div className=" flex flex-col gap-[15px] items-center " >
                    <h1 className="text-center text-5xl leading-tight text-[#1C2045] font-extrabold sm:text-4xl">
                        
                            {check == true ? (
                                <div>
                                <span className="border-b-[10px]  inline-block h-[50px] border-[var(--tree-poppy)] sm:h-[40px]">
                               {underlineHeader}
                               </span>
                                {nameHader1}
                                </div>
                              
                            ) : <span className="border-b-[10px]  inline-block h-[50px] border-[var(--tree-poppy)] sm:h-[40px]">
                            {nameHader}
                            </span>}
                        
                       
                        {check == false ? (
                               
                                <span>
                                     {underlineHeader}
                               </span>
                               
                              
                            ) : null}
                       
                    </h1>
                    <p className="text-center text-[#3A505F] text-[18px] max-w-[980px]">{desHeader}</p>
                </div>)
            )}

            </div>

      
    )


}

Headerkeyfeatures.propTypes = { 
    nameHader: PropTypes.string,
    underlineHeader : PropTypes.string,
    desHeader: PropTypes.string,
    descac: PropTypes.string,
    // tinh: PropTypes.string,
    check: PropTypes.bool,
    nameHader1: PropTypes.string
}